import React from 'react';
import PriceCard from '../layout/priceCard';

const APP_SIGNUP_URL = 'https://app.homebutler.us';

function PriceCards() {
  const free = {
    title: 'Homeowner (Free)',
    id: 1,
    price: '$0',
    highlighted: false,
    comingSoon: false,
    ctaHref: APP_SIGNUP_URL,
    ctaLabel: 'Sign up free',
    features: [
      {
        title: '1 property',
        enabled: true,
      },
      {
        title: '1 active project at a time',
        enabled: true
      },
      {
        title: 'Schedule view',
        enabled: true
      },
      {
        title: 'Browse pros',
        enabled: true
      }
    ]
  }
  const pro = {
    title: 'Pro',
    id: 2,
    price: '$9.99',
    annualPrice: '$89/yr',
    annualNote: 'save 26%',
    highlighted: true,
    comingSoon: false,
    ctaHref: APP_SIGNUP_URL,
    ctaLabel: 'Sign up',
    features: [
      {
        title: 'Everything in Free',
        enabled: true,
      },
      {
        title: 'Unlimited projects & properties',
        enabled: true
      },
      {
        title: 'Unlimited quote requests',
        enabled: true
      },
      {
        title: 'Priority pro matching',
        enabled: true
      },
      {
        title: 'Financial dashboard',
        enabled: true
      },
      {
        title: 'Monthly & yearly spend reports',
        enabled: true
      },
      {
        title: 'Home Health PDF report',
        enabled: true
      },
      {
        title: 'AI Capture',
        enabled: false
      }
    ]
  }
  const concierge = {
    title: 'Concierge',
    id: 3,
    price: '$49.99',
    annualPrice: '$449/yr',
    annualNote: 'save 25%',
    highlighted: false,
    comingSoon: true,
    ctaHref: APP_SIGNUP_URL,
    ctaLabel: 'Sign up',
    features: [
      {
        title: 'Dedicated home manager',
        enabled: true,
      },
      {
        title: 'Pro sourcing & vetting',
        enabled: true
      },
      {
        title: 'Quote negotiation',
        enabled: true
      },
      {
        title: 'Appointment scheduling',
        enabled: true
      },
      {
        title: 'Project oversight',
        enabled: true
      },
      {
        title: 'Emergency priority line',
        enabled: true
      }
    ]
  }

  const levels = [free, pro, concierge];

  return (
    <>
    {levels.map((level) => {
      return (
        <PriceCard
          title={level.title}
          price={level.price}
          annualPrice={level.annualPrice}
          annualNote={level.annualNote}
          highlight={level.highlighted}
          comingSoon={level.comingSoon}
          ctaHref={level.ctaHref}
          ctaLabel={level.ctaLabel}
          features={level.features}
          key={level.id}
        />
      )
    }
    )}
    </>
  );
}

export default PriceCards;
